/* eslint-disable @typescript-eslint/no-explicit-any */
import Box from '@mui/material/Box';
// import Modal from '@mui/material/Modal';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Dialog from '@jobseeker/lotus/components/Dialog';
// import {faker} from '@faker-js/faker';
import {Button, Typography, useTheme} from '@mui/material';
import {shallowEqual, useSelector} from 'react-redux';
import {useEffect, useState} from 'react';

import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  // Legend,
  Tooltip,
  LineController,
  BarController,
} from 'chart.js';
import {Chart} from 'react-chartjs-2';
import {Image} from '@jobseeker/lotus/components/Image';

import type {JobDetail as JB} from '@jobseeker/common-core/stateModels/job/jobdetail.models';
import type {AppState} from '@jobseeker/common-core/types';
import {InsightsModalProps} from '../type';

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  // Legend,
  Tooltip,
  LineController,
  BarController
);

const TabMap = [
  {
    first: 'competitionData',
    second: 'competitionDataRecruiterActions',
    label: 'Competition Data',
  },
  {
    first: 'appliedData',
    second: 'appliedDataRecruiterActions',
    label: 'Applied Data',
  },
  {
    first: 'viewData',
    second: 'viewDataRecruiterActions',
    label: 'View Data',
  },
];
const InsightsModal = (props: InsightsModalProps) => {
  const [value, setValue] = useState(0);

  const jobDetailInsights = useSelector(
    (state: AppState) => state.jobDetail.jobDetailInsights,
    shallowEqual
  );

  const jobDetail: JB = useSelector((state: any) => state.jobDetail);

  const theme = useTheme();
  const [chartData, setChartData] = useState<any>(undefined);
  // const [chartKey, setChartKey] = useState<any>({});
  // const [chartLabels, setChartLabels] = useState<string[]>([]);
  useEffect(() => {
    if (jobDetailInsights?.competitionData) {
      const valuesOne = Object.values(
        jobDetailInsights[TabMap[value].first]
      ).map((v: any) => parseInt(v));
      const valuesTwo = Object.values(
        jobDetailInsights[TabMap[value].second]
      ).map((v: any) => parseInt(v));
      const xAxis = {
        title: {
          display: true,
          text: 'Experience',
        },
      };
      setChartData({
        labels: Object.keys(jobDetailInsights[TabMap[value].first]),
        datasets: [
          {
            type: 'line' as const,
            label: 'Recruiter Actions',
            borderColor: theme.palette.primary.light,
            borderWidth: 2,
            fill: false,
            data: valuesTwo,
          },
          {
            type: 'bar' as const,
            label: value == 2 ? 'View' : 'Applications',
            backgroundColor: theme.palette.primary.dark,
            data: valuesOne,
            maxBarThickness: 50,
          },
        ],
        options: {
          scales: {
            y: {
              suggestedMin: 0,
              suggestedMax: Math.max(...valuesOne.concat(valuesTwo)) * 1.3,
              title: {
                display: true,
                text: 'No. of Candidates',
              },
            },
            x: [0, 1].includes(value) ? xAxis : {},
          },
        },
      });
    }
  }, [value, jobDetailInsights]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const getArraySum = (arr: any[]) => {
    return arr ? arr.reduce((partialSum: any, a: any) => partialSum + a, 0) : 0;
  };
  return (
    <div>
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        BottomAction={
          <Button onClick={props.handleClose} variant="outlined">
            {' '}
            Close
          </Button>
        }
        title={jobDetail.title}
        fullScreen
        scroll={'paper'}
      >
        <Box sx={{px: {xxs: 1, md: 5, lg: 10, xl: 15}}}>
          <Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Image
                src={jobDetail?.recruiter?.profilePicUrl}
                alt={jobDetail?.companyData?.companyName}
                width={125}
                height={125}
                style={{objectFit: 'contain'}}
              />
              <Box>
                <Typography variant="caption" color="dustGreen.main">
                  Posted By
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  {jobDetail?.recruiter?.recruiterName}
                </Typography>
                <Typography variant="subtitle2" color="text.secondary">
                  {jobDetail?.recruiter?.designation} at{' '}
                  {jobDetail?.companyData?.companyName}
                </Typography>
              </Box>
              <Box>
                <Typography variant="h4" color="text.secondary">
                  {getArraySum(
                    Object.values(jobDetailInsights?.appliedData || {})
                  )}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  Total Applications
                </Typography>
              </Box>

              <Box>
                <Typography variant="h4" color="text.secondary">
                  {getArraySum(
                    Object.values(
                      jobDetailInsights?.appliedDataRecruiterActions || {}
                    )
                  )}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  Action Taken
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box>
            <Box sx={{mb: 5}}>
              <Tabs value={value} onChange={handleChange}>
                <Tab label="Competition" />
                <Tab label="Applied" />
                <Tab label="View" />
              </Tabs>
            </Box>
            <Box>
              <Box sx={{px: {xxs: 1, md: 15, lg: 20, xl: 30}}}>
                {value == 0 && (
                  <>
                    <Typography
                      sx={{
                        textAlign: 'center',
                        mb: 5,
                        position: 'absolute',
                        right: 0,
                        left: 0,
                        mt: 2,
                      }}
                    >
                      Distribution of applications by experience (yrs) Total
                      number of applicants:{' '}
                      <b>
                        {getArraySum(
                          Object.values(jobDetailInsights?.appliedData || {})
                        )}
                      </b>
                      <br />
                      Total number of applicants from Top B Schools:{' '}
                      <b>{jobDetailInsights?.totalApplicantsFromTopBSchool}</b>
                    </Typography>
                  </>
                )}
                {chartData && (
                  <Chart
                    type="bar"
                    data={chartData}
                    options={chartData.options}
                  />
                )}
                ;
              </Box>
            </Box>
          </Box>
        </Box>
      </Dialog>
    </div>
  );
};

export default InsightsModal;
